<div
    class="betslip-bar__bar"
    *ngIf="vm$ | async as model"
    [ngClass]="{
        'hidden': !model.visible,
        'accaboost-bar-visible': [notificationTypeEnum.Ladder, notificationTypeEnum.MaxReward].includes(model.accaBoostNotification?.accaBoost?.type),
    }">
    <div class="betslip-bar__content" (click)="barClicked(model)">
        <span class="betslip-bar__counter" [ngClass]="{ empty_state: model.pickCount === 0 }">{{ model.pickCount }}</span>
        <div class="betslip-bar__data">
            <div class="betslip-bar__title">
                {{ translations.Title }}
                <span class="betslip-bar__betbuilder-tag" *ngIf="model.betBuilderBadge">{{ getBetBuilderBadge(model) }}</span>
                <ng-container *ngIf="!myBetsShown; else odds"></ng-container>
            </div>
            <div
                class="betslip-bar__messages"
                *ngIf="model.returnsMessage && !model.showUndo"
                [innerHTML]="model.returnsMessage | msTrust: 'html'"></div>
            <div class="betslip-bar__messages" *ngIf="model.errorMessage">
                @if (model.showUndo) {
                    <div class="betslip-bar__undo_message">
                        <span class="d-flex ui-icon-size-sm theme-warning p-0"> </span>
                        <span class="text-nowrap ml-small"
                            >{{ model.errorMessage }}&nbsp;
                            <span class="undo_link"
                                ><a (click)="removeLastLeg($event, model)">{{ translations.Undo }}</a></span
                            ></span
                        >
                    </div>
                } @else {
                    <span class="text-nowrap ml-small">{{ model.errorMessage }}</span>
                }
            </div>
        </div>
    </div>
    <div class="betslip-bar__side" (click)="myBetsShown ? myBetsClicked(model) : barClicked(model)">
        <ng-container *ngIf="myBetsShown; else odds">
            <a class="betslip-bar__my-bets-btn">{{ translations.MyBets }}</a>
        </ng-container>
    </div>

    <ng-template #odds>
        <span
            class="betslip-bar__odds"
            *ngIf="oddsVisible(model.odds)"
            [ngClass]="{ 'betslip-bar__odds--highlighted theme-reward-odds-boost': model.hasBoostedOdds }"
            >{{ model.odds | bsOddsFormatter: model.oddsDisplayFormat : false : true }}</span
        >
    </ng-template>

    <bs-betbuilder-notification *ngIf="shouldShowNotification" />
</div>
